import ModifierType from "./ManageModifiersTab/ModifierType";
import { Card, Tabs } from "antd";
import CustomQuestionType from "./ManageModifiersTab/CustomQuestionType";
import {
  addDeleteGetLocalStorage,
  storageKeys,
} from "../../utils/global/localData";
import { jwtDecode } from "jwt-decode";

const ManageModifiers = () => {
  const userAccess = addDeleteGetLocalStorage(
    storageKeys?.USER_TOKEN,
    {},
    "get"
  );
  let permissionJson = [];
  if (userAccess) {
    const decoded = jwtDecode(userAccess);
    permissionJson = decoded?.user?.rolePermission?.permissionJson;
  }

  return (
    <>
      <Card className="relative">
        <div className="min-h-[calc(100vh_-_305px)]">
          <Tabs defaultActiveKey="1">
            <Tabs.TabPane tab={"Modifier type"} key={1}>
              <ModifierType permissionJson={permissionJson} />
            </Tabs.TabPane>
            <Tabs.TabPane tab={"Custom question type"} key={2}>
              <CustomQuestionType permissionJson={permissionJson} />
            </Tabs.TabPane>
          </Tabs>
        </div>
      </Card>
    </>
  );
};
export default ManageModifiers;
